<template>
  <el-dialog :title="title" :visible.sync="dialogVisibleBlacklist" width="1072px">
    <div style="color:#4E555B;padding:0 0 20px 330px;">{{fileName}}</div>
    <div class="parentDiv">
      <div class="item1" :style="{backgroundImage: background}" style="overflow-y: auto;">
        <pdf v-if="fileExt === '.pdf'" ref="pdf" :src="url" style="overflow-y: auto;"></pdf>
        <span class="span">{{inIndex}}/{{maxIndex}}</span>
      </div>
      <div class="item2">
        <div
          style="overflow: hidden;position:relative"
          v-for="(item,index) in params"
          :key="index"
          @click="changeImage(index)"
        >
          <div class="ins" :class="inIndex===index+1?'active':''">
            <el-image
              v-if="fileExt !== '.pdf'"
              :src="item.url2"
              fit="fill"
              style="width:192px;height:108px;"
            ></el-image>
            <pdf v-else ref="pdf" :src="item.url2"></pdf>
          </div>
          <span
            :class="inIndex===index+1?'active1':''"
            :style="{backgroundColor:item.bgColor}"
            class="indexClass"
          >{{index+1}}</span>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
// import { } from '@/api/supplier/supplierManage'
import Pdf from 'vue-pdf'

export default {
  components: {
    Pdf
  },
  props: {
    title: {
      type: String,
      default: '查看资格证书'
    }
  },
  data () {
    return {
      bgBorder: '',
      bgColor: '',
      background: '',
      fileExt: '',
      srcList: [],
      url: '', // 大图
      url2: '',
      inIndex: 1, // 当前index
      maxIndex: '', // 最大张数
      fileName: '',
      dialogVisibleBlacklist: false,
      params: []
    }
  },
  methods: {
    changeImage (i) {
      this.url = this.params[i].url2
      this.background = 'url(' + this.url + ')'
      this.bgBorder = '4px #000 solid'
      this.inIndex = i + 1
      this.fileName = this.params[i].fileName
    },
    // 初始
    onBlackDialog (val) {
      this.params = val
      this.params.forEach(ele => {
        ele.url2 = this.$store.state.https + ele.filePath // 初始小图
        this.fileExt = ele.fileExt // 文件尾缀
      })
      this.url = this.params[0].url2 // 大图
      this.background = 'url(' + this.url + ')' // 大图背景
      this.targetsrc = this.params[0].url2 // pdf
      this.fileName = this.params[0].fileName // 初始标题
      this.maxIndex = val.length
      this.dialogVisibleBlacklist = true
    }
  }
}
</script>
<style lang="scss" scoped>
.parentDiv {
  padding-top: 101px 30px 60px 30px;
  padding-bottom: 50px;
  display: flex; /* 弹性布局 */
  width: 1030px;
  height: 450px;
  justify-content: space-between; /* 横向中间自动空间 */
  align-content: space-between; /* 竖向中间自动空间 */
  .item1 {
    width: 800px;
    height: 450px;
    background-color: #e9e9e9;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .item2 {
    width: 216px;
    overflow-y: auto;
    overflow-x: hidden;
    .ins {
      width: 192px;
      height: 108px;
      border: 8px solid #fff;
      background-color: #e9e9e9;
      margin-bottom: 30px;
      overflow: hidden;
    }
    .active {
      border: solid #276cff0d 8px;
    }
    .active1 {
      background-color: #276cff;
      color: #ffffff !important;
    }
    // 小图的下标
    .indexClass {
      z-index: 999;
      position: absolute;
      bottom: 2px;
      left: 96px;
      height: 20px;
      width: 20px;
      color: #4e555b;
      font-size: 14px;
      text-align: center;
    }
  }
}
.span {
  position: absolute;
  text-align: center;
  bottom: 25px;
  left: 398px;
}
.url2Image {
  margin-bottom: 20px;
}
.el-dialog-div {
  height: 611px;
  overflow: hidden;
}
</style>
